import type { ReactElement } from 'react';
import { useState } from 'react';
import type { MarginBottomProps } from 'styled-system';

import { EventBusEvent } from 'common/enums/EventBus';
import { useSubscriptionCallback } from 'common/hooks/subscription';
import { CartUpdateStatus } from 'common/types/Cart';
import type { CartUpdateState } from 'common/types/Cart';
import type { SectionHeaderProps } from '../types';

export interface SectionHeaderWrapperProps extends SectionHeaderProps, MarginBottomProps {
  children: (props: SectionHeaderProps & MarginBottomProps) => ReactElement<any>;
}

export const CartSectionHeaderWrapper = ({
  subHeadingTranslationProps: initialSubHeadingTranslationProps,
  ...props
}: SectionHeaderWrapperProps) => {
  const [subHeadingTranslationState, setSubHeadingTranslationState] = useState(
    initialSubHeadingTranslationProps
  );

  useSubscriptionCallback<CartUpdateState>(EventBusEvent.CartUpdate, data => {
    if (data.status === CartUpdateStatus.Success && data.transformed === false) {
      setSubHeadingTranslationState({
        articlesCount: data.cart.totalItems,
      });
    }
  });

  return props.children({
    ...props,
    subHeadingTranslationProps: subHeadingTranslationState,
  });
};
